var _polygon, _path, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon3, _path17, _polygon4, _path18, _circle2, _circle3, _path19, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _circle4, _circle5, _circle6, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 561.82155,
    height: 595.22246,
    viewBox: "0 0 561.82155 595.22246",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "452.988 570.009 438.754 570.009 431.98 515.106 452.988 515.106 452.988 570.009",
    fill: "#ffb6b6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M779.5899,747.05981H769.38205L767.56,737.42239l-4.66656,9.63742H735.81976a6.08591,6.08591,0,0,1-3.45821-11.09406l21.62022-14.9317,0-9.74311,22.74071,1.35731Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "335.988 569.009 321.754 569.009 314.98 514.106 335.988 514.106 335.988 569.009",
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M662.5899,746.05981H652.38205L650.56,736.42239l-4.66656,9.63742H618.81976a6.08591,6.08591,0,0,1-3.45821-11.09406l21.62022-14.9317,0-9.74311,22.74071,1.35731Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M797.37851,691.66431c-3.05,12.97-51.85,10.68-61,12.2-9.15,1.53-22.3-207.26-22.3-207.26-13.92109.00556-40.44,97.89-40.44,97.89s9.42617,103.36769-2,105c-7,1-55.99-2.91-62.85-5.96-5.06846-2.25344,44.94269-222.48658,44.94269-222.48658l28.90729-54.5534,34.49-3h29.74l1.91,6.86c5.217-5.5278,26.37415,18.45184,19.6297,75.98169C758.39408,581.75633,799.18418,683.99161,797.37851,691.66431Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M759.63852,420.49432s-26.97322,33-56.97322,24-38.02678-12-38.02678-12c7.98954-19.95751,15.65353-52.7115-2.47449-70.68438-24.52551-24.31562-4.33887-25.2506-8.56317-38.87464L641.23823,297.512l26.36183-1.15094,6.2931-9.15269a8.91991,8.91991,0,0,1,8.73029-5.35892l12.834.78531a8.9199,8.9199,0,0,1,8.1,6.705l6.1078,6.15458,27.16409,10.19831L720.6653,325.49432l15.97322,70C749.651,401.89008,757.6412,410.10608,759.63852,420.49432Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#eeb808"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M808.16229,467.85919a9.15745,9.15745,0,0,0-4.13167-13.42026l-30.29127-77.51462L758.087,386.02476l33.61312,73.874a9.20709,9.20709,0,0,0,16.46218,7.96046Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#ffb6b6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M732.90767,304.76054s4.02235-2.68773,7.91587,6.79355c3.11705,7.5905,46.07942,85.95113,47.46382,97.25925a7.194,7.194,0,0,1,6.34344,6.12754l-23.0345,5.48536c-4.42752-3.02971-5.967-7.56979-4.52752-9.10864l-6.46708-13.33516-44.97-75.57653,14.33394-15.75418Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#eeb808"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M529.94208,234.23748a9.15744,9.15744,0,0,0,10.60627,9.20224l66.715,49.75125,8.46753-16.00361L548.12317,232.283a9.20709,9.20709,0,0,0-18.18109,1.9545Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#ffb6b6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M680.09177,332.825s-1.9913,4.40885-10.3115-1.57685c-6.66095-4.792-84.576-48.5573-91.73351-57.42071a7.194,7.194,0,0,1-8.62479-1.8436l16.64449-16.84156c5.36.22849,9.0684,3.26663,8.661,5.33405l12.543,7.89443,78.1457,40.34058-3.82848,20.9523Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#eeb808"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M666.0076,246.19405c0,16.19749,8.103,32.68,24.30048,32.68s38.54559-11.73127,33.5179-36.86969c-3.17659-15.88295-12.29272-25.13843-28.49021-25.13843A29.32817,29.32817,0,0,0,666.0076,246.19405Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 370.19373,
    cy: 101.93492,
    r: 24.12636,
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M714.53223,260.64858c-.21866-.03456-.43733-.08063-.656-.11519-3.76337-.66746-7.52667-1.32339-11.27852-2.00251l-.34532-8.50481-4.54588,7.61862c-10.36935,3.44109-20.07118,1.49619-29.19758-2.79654a82.43173,82.43173,0,0,1-8.74665-4.82208c-1.96328-11.97989,2.98964-21.421,15.70942-22.62616.395-.03742.679-.36821,1.02428-.541a.01126.01126,0,0,0,.01145-.01152c.587-.2762,1.18543-.54087,1.7839-.78251a26.576,26.576,0,0,1,27.89709,5.409C713.554,238.50585,716.86846,250.11809,714.53223,260.64858Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M705.28838,226.24819v.02041a14.59054,14.59054,0,0,0,.47918,3.74194c.051.21414.11221.43843.18359.65256v.01021a14.80133,14.80133,0,0,0,9.12543,9.50274c.31607.12235.64235.22428.96864.31608a13.226,13.226,0,0,0,2.10038.42821,13.40272,13.40272,0,0,0,1.92707.13256,14.67232,14.67232,0,0,0,1.509-.07138,14.27757,14.27757,0,0,0,3.43607-.78512,4.31854,4.31854,0,0,0,.5098-.18352,2.48666,2.48666,0,0,0,.24476-.10194,14.79895,14.79895,0,0,0,7.63685-20.03529l-.01021-.01021A14.50256,14.50256,0,0,0,730.493,215.787c-2.67136-2.66116-3.84849-9.3304-7.9065-9.3304a5.54686,5.54686,0,0,0-.58119.02035c-2.72233.0918-7.75463,5.96577-9.89578,7.35242a14.43223,14.43223,0,0,0-4.058,3.84394,14.61373,14.61373,0,0,0-2.38591,5.26114A14.8054,14.8054,0,0,0,705.28838,226.24819Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M723.35206,221.1001c2.296,2.673,5.8908,3.7121,9.13365,5.10312a38.424,38.424,0,0,1,22.32293,28.07124c.89656,5.00252.77929,10.181,2.19542,15.05789,1.40775,4.87686,4.89359,9.66156,9.89616,10.5079,3.38529.57818,6.779-.729,9.96316-2.01948q2.627-1.05577,5.25394-2.12-2.74006-6.87539-5.47177-13.75074a69.68465,69.68465,0,0,0,10.14754,11.87375q9.41431-3.79593,18.84543-7.59185c-15.46853.05866-12.829-14.95734-16.2897-30.02362-1.90216-8.27893-18.09965-13.8848-21.2755-21.76153a24.09632,24.09632,0,0,0-43.70732-2.19542C721.19014,213.51668,721.098,218.46059,723.35206,221.1001Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M611.46741,316.0468H432.15917l1.35249-1.47256c8.488-9.24187,13.74188-26.922,16.0635-54.04813a29.29855,29.29855,0,0,1,29.29851-27.03179h86.019a29.31186,29.31186,0,0,1,29.2925,26.994c2.06519,23.693,7.25731,40.91,16.34137,54.1845Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M564.89271,745.99432h-86.019a29.29845,29.29845,0,0,1-29.29851-27.03092c-2.32162-27.127-7.57549-113.80626-16.0635-123.04985l-1.35249-1.4717H611.46741l-.94083,1.37393c-9.08406,13.27447-14.27618,99.49234-16.34137,123.18364A29.31259,29.31259,0,0,1,564.89271,745.99432Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M651.95634,373.131a6.96017,6.96017,0,0,0-3.59885,1.02112,69.41,69.41,0,0,0-69.32432-66.00924H464.04881a69.41032,69.41032,0,0,0-69.41029,69.4103V535.57006a69.41033,69.41033,0,0,0,69.41029,69.4104H579.03317a69.41034,69.41034,0,0,0,69.4103-69.4104V424.84954a6.95347,6.95347,0,0,0,3.51287.97449,7.02575,7.02575,0,0,0,7.02574-7.02574V380.1567A7.02567,7.02567,0,0,0,651.95634,373.131Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M636.96853,368.98431c-.04-.89-.11-1.77-.2-2.65a51.96059,51.96059,0,0,0-51.65-46.77h-126.27a51.95333,51.95333,0,0,0-51.65,46.77c-.09.88-.16,1.76-.2,2.65q-.06,1.245-.06,2.49v168.42a51.9602,51.9602,0,0,0,51.91,51.91h126.27a51.96663,51.96663,0,0,0,51.91-51.91v-168.42Q637.02853,370.22928,636.96853,368.98431Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.939 368.606 317.939 374.566 317.139 372.946 296.769 331.896 296.749 331.886 239.519 216.596 239.519 216.586 238.199 213.946 238.199 213.926 214.999 167.176 217.969 167.176 241.159 213.926 241.179 213.946 242.489 216.586 242.489 216.596 298.259 328.956 298.259 328.966 299.579 331.606 299.579 331.626 317.939 368.606",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M645.63852,367.49432l-239.28,1.49v-2.65l238.28-.84C645.35849,366.36432,644.95846,366.60431,645.63852,367.49432Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "318.449 375.596 87.849 375.596 87.849 372.946 317.939 372.946 317.939 374.566 318.449 375.596",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M571.63005,378.98522a53.27522,53.27522,0,0,0-74.233,12.88287l0,0c-16.94135,24.05637-33.94071,87.13821-21.94086,123.682,35.79257-37.80686,90.78067-41.73545,109.05673-62.33188C604.04155,431.21019,595.68644,395.92656,571.63005,378.98522Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#eeb808"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "b452c1c8-53ab-4ced-a544-b8816c88fdab",
    "data-name": "af3c8991-f89c-43e0-a050-89c81726f2a6",
    cx: 221.1411,
    cy: 263.69575,
    r: 17.37482,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "a24bae02-bdbe-4fd0-a0d6-bc02ca4e3c9e",
    "data-name": "a49e5b2e-c339-415c-b240-8977b61bd9a6",
    cx: 141.67924,
    cy: 370.70335,
    r: 11.38013,
    fill: "#eeb808"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M558.81932,412.07543a17.37449,17.37449,0,0,1-30.0083,17.52124,17.37227,17.37227,0,0,0,26.4519-21.83054A17.3753,17.3753,0,0,1,558.81932,412.07543Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.54564,453.30013c-18.276,20.5964-73.26416,24.525-109.05671,62.33188a73.69484,73.69484,0,0,1-2.57266-10.57761c35.77475-34.3699,87.70163-38.7135,105.35965-58.61331,15.8042-17.81076,13.344-44.31482-.91913-62.7565C596.91844,401.81752,602.44175,433.13188,584.54564,453.30013Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M373.13027,746.42123a1.18647,1.18647,0,0,0,1.19006,1.19h488.29a1.19,1.19,0,0,0,0-2.38h-488.29A1.18651,1.18651,0,0,0,373.13027,746.42123Z",
    transform: "translate(-319.08922 -152.38877)",
    fill: "#ccc"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 824.60731,
    cy: 497.05936,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-442.92021 178.80915) rotate(-21.16137)",
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 873.61083,
    cy: 490.77321,
    rx: 7.55666,
    ry: 5.2568,
    transform: "matrix(0.93257, -0.361, 0.361, 0.93257, -437.3465, 196.07532)",
    fill: "#e6e6e6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 820.35739,
    cy: 538.86753,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-458.29938 180.09418) rotate(-21.16137)",
    fill: "#e6e6e6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 806.97872,
    cy: 557.56422,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-425.81456 48.47193) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 806.68713,
    cy: 588.78681,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-433.01383 49.24424) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 849.69612,
    cy: 524.11757,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-416.96234 57.41165) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 823.88724,
    cy: 517.85023,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-416.21272 51.29864) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 851.24278,
    cy: 489.09947,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-408.85512 56.82636) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.54535,
    cy: 622.2486,
    rx: 5.25681,
    ry: 7.55666,
    transform: "translate(-517.5618 4.89033) rotate(-20.69095)",
    fill: "#e6e6e6"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.66175,
    cy: 573.19513,
    rx: 5.2568,
    ry: 7.55666,
    transform: "translate(-500.60937 -0.35246) rotate(-20.69095)",
    fill: "#e6e6e6"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.31722,
    cy: 626.84164,
    rx: 5.25681,
    ry: 7.55666,
    transform: "translate(-516.49035 19.94572) rotate(-20.69095)",
    fill: "#e6e6e6"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.90344,
    cy: 640.37337,
    rx: 4.77581,
    ry: 3.3223,
    transform: "translate(-451.65487 -49.22908) rotate(-12.84594)",
    fill: "#e6e6e6"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.12258,
    cy: 640.92129,
    rx: 4.77581,
    ry: 3.3223,
    transform: "translate(-450.99532 -42.2744) rotate(-12.84594)",
    fill: "#e6e6e6"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 358.80864,
    cy: 597.3828,
    rx: 4.77581,
    ry: 3.3223,
    transform: "translate(-442.92508 -57.66305) rotate(-12.84594)",
    fill: "#e6e6e6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.32961,
    cy: 623.13935,
    rx: 4.77581,
    ry: 3.3223,
    transform: "translate(-448.8137 -58.45889) rotate(-12.84594)",
    fill: "#e6e6e6"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.80442,
    cy: 595.54868,
    rx: 4.77581,
    ry: 3.3223,
    transform: "translate(-443.3934 -65.49146) rotate(-12.84594)",
    fill: "#e6e6e6"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 414.60731,
    cy: 165.05936,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-350.71693 8.41318) rotate(-21.16137)",
    fill: "#e6e6e6"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 463.61083,
    cy: 158.77321,
    rx: 7.55666,
    ry: 5.2568,
    transform: "translate(-345.14322 25.67936) rotate(-21.16137)",
    fill: "#e6e6e6"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.35739,
    cy: 206.86753,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-366.09609 9.69821) rotate(-21.16137)",
    fill: "#e6e6e6"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.97872,
    cy: 225.56422,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-360.36939 -54.88886) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.68713,
    cy: 256.78681,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-367.56866 -54.11655) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.69612,
    cy: 192.11757,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-351.51717 -45.94914) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.88724,
    cy: 185.85023,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-350.76754 -52.06215) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.24278,
    cy: 157.09947,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-343.40994 -46.53443) rotate(-13.31636)",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.54929,
    cy: 408.10556,
    r: 25,
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.54929,
    cy: 408.10556,
    r: 14,
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.54929,
    cy: 408.10556,
    r: 14,
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.84907,
    y: 262.69565,
    width: 70.625,
    height: 2,
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.c7505a873a144cc928137a52e79661dd.svg";
export { ForwardRef as ReactComponent };